import React, { useState } from 'react';
import { EditEntityDrawer } from './EditEntityDrawer';
import { useMutation } from 'react-query';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { useStore } from '../../../store';

const FormModel = z.object({
    entityName: z
        .string()
        .min(1)
        .trim(),
    firstName: z.string().trim(),
    lastName: z.string().trim(),
    email: z.email('Invalid email address').trim(),
    phoneNumber: z.string().trim()
});

export const useEditEntityDrawer = () => {
    const {
        financeEntity: { update }
    } = useStore();

    const [isOpen, setIsOpen] = useState(false);

    const form = useForm({
        resolver: zodResolver(FormModel)
    });

    const closeModal = () => {
        setIsOpen(false);
    };

    const updateMutation = useMutation(
        data =>
            update({
                name: data.entityName,
                main_contact_first_name: data.firstName,
                main_contact_last_name: data.lastName,
                main_contact_email: data.email,
                main_contact_phone_number: data.phoneNumber
            }),
        {
            onSuccess: closeModal
        }
    );

    const open = data => {
        form.reset({
            entityName: data.name,
            firstName: data.main_contact_first_name,
            lastName: data.main_contact_last_name,
            email: data.main_contact_email,
            phoneNumber: data.main_contact_phone_number
        });
        setIsOpen(true);
    };

    const onSubmit = fields => {
        updateMutation.mutate(fields);
    };

    const render = () => {
        return (
            <FormProvider {...form}>
                <EditEntityDrawer isOpen={isOpen} onClose={closeModal} onSubmit={form.handleSubmit(onSubmit)} isSubmitting={updateMutation.isLoading} />
            </FormProvider>
        );
    };

    return {
        open,
        render
    };
};
